"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.Headline4 = exports.Headline3 = exports.Headline2 = exports.Headline1 = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var tokens_1 = require("../../../tokens");
exports.Headline1 = styled_components_1.default.div(__assign({ overflowWrap: 'break-word', hyphens: 'auto' }, tokens_1.headline1));
exports.Headline2 = styled_components_1.default.div(__assign({ overflowWrap: 'break-word', hyphens: 'auto' }, tokens_1.headline2));
exports.Headline3 = styled_components_1.default.div(__assign({ overflowWrap: 'break-word', hyphens: 'auto' }, tokens_1.headline3));
exports.Headline4 = styled_components_1.default.div(__assign({ overflowWrap: 'break-word', hyphens: 'auto' }, tokens_1.headline4));
exports.H1 = styled_components_1.default.h1(__assign({ margin: 0 }, tokens_1.headline1));
exports.H2 = styled_components_1.default.h2(__assign({ margin: 0 }, tokens_1.headline2));
exports.H3 = styled_components_1.default.h3(__assign({ margin: 0 }, tokens_1.headline3));
exports.H4 = styled_components_1.default.h3(__assign({ margin: 0 }, tokens_1.headline4));
//# sourceMappingURL=index.js.map